import React, { useEffect, useState } from 'react';
import { get } from '../Services/http';
import ProductPageBuyBox from '../Components/ProductPage/ProductPage.BuyBox';
import ProductPageDescription from '../Components/ProductPage/ProductPage.Description';
import ProductPageImageSlider from '../Components/ProductPage/ProductPage.ImageSlider';
import Products from '../Blocks/Products/Products';
import { translate } from '../Services/translation';

const ProductPage = ({
  product,
  sliderImages,
  fieldGroups,
  seller,
  uspText,
  visibleFields,
}) => {
  const [accessories, setAccessories] = useState([]);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [popularProducts, setPopularProducts] = useState([]);

  const fetchUpsellProducts = async () => {
    try {
      const response = await get(
        `/api/products/${product.variantSystemId}/upsell`
      );
      const data = await response.json();
      if (data && typeof data === 'object') {
        if (Array.isArray(data.accessories)) {
          setAccessories(data.accessories);
        }

        if (Array.isArray(data.similarProducts)) {
          setSimilarProducts(data.similarProducts);
        }

        if (Array.isArray(data.popularProducts)) {
          setPopularProducts(data.popularProducts);
        }
      }
    } catch (error) {
      console.error('Error fetching upsell products:', error);
    }
  };

  useEffect(() => {
    fetchUpsellProducts();
  }, [product.id]);

  return (
    <>
      <div className="product-page__top">
        <div className="product-page__left">
          <ProductPageImageSlider images={sliderImages} />
          <ProductPageBuyBox
            className="buy-box buy-box--mobile"
            product={product}
            seller={seller}
            uspText={uspText}
            visibleFields={visibleFields}
          />
          <ProductPageDescription
            product={product}
            productFields={fieldGroups}
          />
        </div>
        <div className="product-page__right">
          <ProductPageBuyBox
            className="buy-box buy-box--desktop"
            id="buy-box"
            product={product}
            seller={seller}
            uspText={uspText}
            visibleFields={visibleFields}
          />
        </div>
      </div>
      {accessories.length > 0 && (
        <div className="product-page__middle">
          <div className="product-page__carousell">
            <div className="products-block">
              <Products
                products={accessories}
                title={translate('productpage.fits.togheter')}
              />
            </div>
          </div>
        </div>
      )}
      {(similarProducts.length > 0 || popularProducts.length > 0) && (
        <div className="product-page__bottom">
          <div className="product-page__bottom-container">
            {similarProducts.length > 0 && (
              <div className="product-page__carousell">
                <div className="products-block">
                  <Products
                    products={similarProducts}
                    title={translate('productpage.similar.products')}
                  />
                </div>
              </div>
            )}
            {popularProducts.length > 0 && (
              <div className="product-page__carousell">
                <div className="products-block">
                  <Products
                    products={popularProducts}
                    title={translate('productpage.popular.products')}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProductPage;
